import { useCallback, useMemo, useState } from 'react';
import { createHttpClient } from '@wix/http-client';

import { useChatServiceProvider, useChatHistory } from '@wix/chat-service-sdk';
import {
  type OnWidgetAction,
  getChatWidgets,
} from '@wix/chat-widget-common-widgets';
import { useGeneralData } from '../contexts/GeneralDataProvider/GeneralDataContext';

// export * from '@wix/ambassador-genie-chat-service-v1-no-entity/types';
// todo: configs to a separate file
export const STORAGE_KEY = 'Online_Programs_AI_Chat';
const assistantConfig = {
  assistantReference: {
    assistantId: 'c672670a-0979-4ccf-a608-8a9312dcc584',
    assistantVersionId: 'c8ee384c-62ab-49b3-b011-975a6297b736',
  },
};

export const useChatSDK = () => {
  const [isPending, setIsPending] = useState(false);
  const { instance } = useGeneralData();
  // todo: what is the proper method to use http client here?
  const httpClient = createHttpClient({
    getAppToken: () => instance,
  });

  const {
    createConversation,
    sendUserMessage,
    messages,
    conversationId,
    loadConversation,
  } = useChatServiceProvider({
    httpClient,
    // pageUrl: '',
    reference: {
      type: 'assistant',
      ...assistantConfig.assistantReference,
    },
    instanceIdForSideEffects: instance,
    onError: (err) => {
      console.error(err);
    },
  });
  const { conversations } = useChatHistory({
    httpClient: httpClient as any,
    enabled: true,
  });
  const onWidgetAction: OnWidgetAction = (
    widgetName,
    data,
    widgetDescription = '',
  ) => {
    if (data.action === 'error') {
      console.error('Error in widget:', {
        widgetName,
        data,
        widgetDescription,
      });
    } else {
      console.log('Widget action:', { widgetName, data, widgetDescription });
    }
  };
  const widgets = useMemo(
    () =>
      getChatWidgets({
        send: async (content: string): Promise<void> => {
          void sendUserMessage(content);
        },
        onWidgetAction,
        httpClient: httpClient as any,
      }),
    [sendUserMessage, onWidgetAction],
  );

  const newConversation = useCallback(async () => {
    setIsPending(true);
    const conversationId = await createConversation({
      firstUserMessage: 'What is this program about?',
      origin: 'web',
    });
    localStorage.setItem(STORAGE_KEY, conversationId);
    setTimeout(() => {
      setIsPending(false);
    }, 300);
  }, []);

  const initConversation = useCallback(async () => {
    setIsPending(true);
    // todo: move storing to the BE?
    const storedConversationId = localStorage.getItem(STORAGE_KEY);
    if (storedConversationId) {
      await loadConversation({ id: storedConversationId });
    } else {
      await newConversation();
    }
    setTimeout(() => {
      setIsPending(false);
    }, 300);
  }, []);

  return {
    conversation: conversationId,
    conversationMessages: messages,
    sendMessage: sendUserMessage,
    initConversation,
    loadConversation,
    isPending,
    widgets,
    onWidgetAction,
    newConversation,
  };
};
